import { Box, Typography } from '@mui/material';
import * as Preact from 'preact';
import * as MaterialHeader from './A_MaterialHeader';
import * as MaterialSwatch from './A_MaterialSwatch';

export type Option = {
    id: string;
    displayName: string | number | null;
    swatch: string;
};

export interface Props {
    name?: string;
    minPrice?: string;
    selectedGlobalOption: string | number | null;
    loading: boolean;
    options: Option[];
    onMaterialClick: (id: string) => void;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                width: '100%',
                boxSizing: 'border-box',
                padding: 0,
            }}
        >
            {(p.name || p.minPrice) && (
                <MaterialHeader.Component name={p.name} minPrice={p.minPrice} />
            )}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: '12px',
                    width: '100%',
                    boxSizing: 'border-box',
                    justifyContent: 'space-between',
                }}
            >
                {p.options.map(o => {
                    return (
                        <Box display="flex" flexDirection="column">
                            <MaterialSwatch.Component
                                id={o.id}
                                selected={!p.loading && p.selectedGlobalOption === o.id}
                                loading={p.loading && p.selectedGlobalOption === o.id}
                                disabled={p.loading}
                                swatch={o.swatch}
                                onClick={() => p.onMaterialClick(o.id)}
                            />
                            <Typography variant="helperText" color="text.secondary" mt="10px">
                                {o.displayName}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

Component.displayName = 'MaterialContainer';
